import React, { useState, useEffect } from 'react';
import { 
    Table, TableBody, TableCell, TableContainer, TableRow, Paper, 
    TableHead, Button, TablePagination, TextField, Dialog, 
    DialogActions, DialogContent, DialogContentText, DialogTitle 
} from '@mui/material';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import AddMedico from './AddMedico';
import { useAccesos } from '../contexts/AccesosContext';

function GestionMedicos() {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [medicos, setMedicos] = useState([]);
    const [editMedico, setEditMedico] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [medicoToDelete, setMedicoToDelete] = useState(null);
    const { user } = useUser();
    const { tienePermiso } = useAccesos();

    useEffect(() => {
        fetchMedicos();
    }, []);

    const fetchMedicos = async () => {
        try {
            const response = await fetch(`${server}/MgMedicoes`);
            const data = await response.json();
            setMedicos(data.$values);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar los médicos: ' + error,
            });
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setPage(0);
    };

    const handleDelete = (medico) => {
        setMedicoToDelete(medico);
        setOpenDialog(true);
    };
    const handleNewMedico = async () => {
        try {
            await fetchMedicos();
            setEditMedico(null);
           
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al actualizar la lista de médicos: ' + error,
            });
        }
    };
    const confirmDelete = async () => {
        try {
            const response = await fetch(`${server}/MgMedicoes/${medicoToDelete.idMedico}`, {
                method: 'DELETE',
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Éxito',
                    text: 'Médico eliminado correctamente',
                });
                fetchMedicos();
            } else {
                throw new Error('Error al eliminar el médico');
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al eliminar el médico: ' + error,
            });
        }
        setOpenDialog(false);
    };

    const filteredMedicos = medicos.filter((medico) =>
        medico.nombreMedico.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <>
            <div className="x_title">
            </div>
            <div className="x_content">
                <br />
                <AddMedico handleNewMedico={handleNewMedico} editMedico={editMedico} />
                <div className="ln_solid" />
    
                <h2>Médicos Existentes</h2>
                <div className="row">
                    <div className="col-md-9 col-sm-4 offset-md-2">
                        <TextField
                            label="Buscar médico"
                            variant="outlined"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ marginBottom: '20px' }}
                            fullWidth
                        />
                        <div className="table-responsive">
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>ID</TableCell>
                                            <TableCell>Nombre</TableCell>
                                            <TableCell>Especialidad</TableCell>
                                            <TableCell>Teléfono</TableCell>
                                            <TableCell>Dirección</TableCell>
                                            <TableCell>Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredMedicos
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((medico) => (
                                                <TableRow key={medico.idMedico}>
                                                    <TableCell>{medico.idMedico}</TableCell>
                                                    <TableCell>{medico.nombreMedico}</TableCell>
                                                    <TableCell>{medico.especialidad}</TableCell>
                                                    <TableCell>{medico.telefono}</TableCell>
                                                    <TableCell>{medico.direccion}</TableCell>
                                                    <TableCell>
                                                        <Button 
                                                            onClick={() => setEditMedico(medico)} 
                                                            color="primary"
                                                            disabled={!tienePermiso('Editar Médico')}
                                                        >
                                                            Editar
                                                        </Button>
                                                        <Button 
                                                            onClick={() => handleOpenDialog(medico)} 
                                                            color="secondary"
                                                            disabled={!tienePermiso('Eliminar Médico')}
                                                        >
                                                            Eliminar
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                    component="div"
                                    count={filteredMedicos.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                            <Dialog
                                open={openDialog}
                                onClose={() => setOpenDialog(false)}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle>{"Confirmar eliminación"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText>
                                        ¿Estás seguro de que deseas eliminar este médico?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setOpenDialog(false)} color="primary">
                                        Cancelar
                                    </Button>
                                    <Button onClick={confirmDelete} color="primary" autoFocus>
                                        Eliminar
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default GestionMedicos;